import React from "react";
import { GameRelation, getTextByLang } from "./Game";
import { useSmartNavigate } from "./Main";

interface RelationGridProps {
    title: string;
    subtitle: string;
    items: GameRelation[];
    lang: string;
    inverse?: boolean
}

export const RelationGrid = ({ title, subtitle, items, lang, inverse }: RelationGridProps) => {
    const navigate = useSmartNavigate();

    return (
        <div className={`relation-wrapper ${inverse ? 'inverse' : ''}`}>
            <div className="relation-section">
                <h2 className="relation-title">{title}</h2>
                <p className="relation-subtitle">{subtitle}</p>
                <div className="relation-grid">
                    {items.map((item, i) => {
                        const url  = getTextByLang(item.link, lang);
                        const name = getTextByLang(item.name, lang);
                        const desc = getTextByLang(item.description, lang);
                        const img  = getTextByLang(item.image, lang);
                        return (
                            <div
                                key={i}
                                className="relation-tile"
                                onClick={() => navigate(url)}
                                role="link"
                                tabIndex={0}
                                onKeyDown={e => { if (e.key === "Enter") navigate(url); }}
                            >
                                {img && (
                                    <img
                                        src={img}
                                        alt={name}
                                        className="relation-tile__img"
                                        draggable={false}
                                    />
                                )}
                                <div className="relation-tile__caption">
                                    {name && <div className="relation-tile__name">{name}</div>}
                                    {desc && <div className="relation-tile__desc">{desc}</div>}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
